<template>
  <b-row>
    <Graphics
      :labels="this.labels"
      :content="this.data"
      :highestValue="this.highestValue"
    />
  </b-row>
</template>

<script>
import Graphics from "../../../../components/graphics/Graphics.vue";

export default {
  components: {
    Graphics,
  },
  data() {
    return {
      labels: null,
      data: null,
      highestValue: 0,
    };
  },
  props: ["datos"],
  watch: {
    datos: function() {
      this.labels = this.datos.labels;
      this.data = this.datos.data;
      this.highestValue = this.datos.highestValue;
    },
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}

.icons {
  text-align: end;
  margin-top: 10px;
}

.bxs-down-arrow-circle {
  font-size: 36px;
  margin-right: 10px;
}

.bxs-image {
  font-size: 36px;
  margin-right: 10px;
}

.bx-file {
  font-size: 36px;
  margin-right: 30px;
}
</style>
